// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"8c5e0248ac70789a2327","339":"d576ea082d4d22534cc3"}[chunkId] + ".js";
};